import { render, staticRenderFns } from "./order-testapi-dialog.vue?vue&type=template&id=6923b6a2"
import script from "./order-testapi-dialog.vue?vue&type=script&lang=js"
export * from "./order-testapi-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports